var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header bg-white" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-dark",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.ADD_TEXT("[$weight]")
                  },
                },
              },
              [_c("span", [_vm._v("Peso")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.ADD()
                  },
                },
              },
              [_vm._m(1)]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-success px-3",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.SAVE()
                  },
                },
              },
              [
                _vm.count == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "spinner-border spinner-border-sm",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    )
                  : _c("span", [_vm._v("Guardar")]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body border-bottom px-0" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-2 d-flex mb-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-h btn-dark",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.ADD_TEXT("[$nationalization]")
                },
              },
            },
            [_c("span", [_vm._v("Nacionalización")])]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "ml-auto mr-2" }, [_vm._v(" = ")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-1 px-lg-1 mb-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.min,
                expression: "data.min",
              },
            ],
            staticClass: "form-control form-control-sm",
            domProps: { value: _vm.data.min },
            on: {
              focus: function ($event) {
                return _vm.SET_INPUT("min")
              },
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "min", $event.target.value)
                },
                _vm.GET_INPUT,
              ],
              keypress: _vm.DOUBLE_OPERATOR,
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-1 px-lg-1 mb-2" },
          [
            _c("v-select", {
              staticClass: "form-control form-control-sm",
              attrs: { items: _vm.mats, "hide-details": "" },
              model: {
                value: _vm.data.mat,
                callback: function ($$v) {
                  _vm.$set(_vm.data, "mat", $$v)
                },
                expression: "data.mat",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-1 px-lg-1 mb-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.max,
                expression: "data.max",
              },
            ],
            staticClass: "form-control form-control-sm",
            attrs: { type: "text" },
            domProps: { value: _vm.data.max },
            on: {
              focus: function ($event) {
                return _vm.SET_INPUT("max")
              },
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "max", $event.target.value)
                },
                _vm.GET_INPUT,
              ],
              keypress: _vm.DOUBLE_OPERATOR,
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body px-0 py-2" },
      [
        _c("v-data-table", {
          staticClass: "elevation-1 no-hover",
          attrs: {
            items: _vm.data.switch.slice().reverse(),
            "hide-default-header": "",
            "hide-default-footer": "",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "item",
                fn: function (ref) {
                  var item = ref.item
                  var index = ref.index
                  return [
                    _c("tr", { attrs: { colspan: "100%" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "container-fluid py-3",
                          class: index != 0 ? "border-top" : "",
                        },
                        [
                          _c("app-switch", {
                            attrs: {
                              data: item,
                              id: index + 1,
                              add_text: _vm.add_text,
                              btn: _vm.btn,
                              set_id: _vm.set_id,
                            },
                            on: {
                              set_id: function (e) {
                                return (_vm.set_id = e)
                              },
                              remove: _vm.REMOVE,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
              },
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Nacionalización")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "bi bi-plus" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }